import moment from "moment";

export const dateMethodMixins = {
  methods: {
    formatDate(date) {
      return moment(date).format("MM/DD/YYYY");
    },
    formatDateAndTime(date) {
      return moment(date).format("MM/DD/YYYY h:mm:ss a");
    },
    formatDateUTC(date) {
      return moment.utc(date).format("MM/DD/YYYY");
    }
  }
};
